const FirebaseConfig = {
  dev: {
    apiKey: "AIzaSyCsK4ajckQiiT4Ujqq4DqjkKGodHbTWYwU",
    authDomain: "fibo-collab-dev.firebaseapp.com",
    databaseURL: "https://fibo-collab-dev.firebaseio.com",
    projectId: "fibo-collab-dev",
    storageBucket: "fibo-collab-dev.appspot.com",
    messagingSenderId: "646196147370"
  },
  test: {
    apiKey: "AIzaSyCarx3QaU1ck-UiQbfw0QuGMHRT5rI6ar4",
    authDomain: "data-migrations.firebaseapp.com",
    databaseURL: "https://data-migrations.firebaseio.com",
    projectId: "data-migrations",
    storageBucket: "data-migrations.appspot.com",
    messagingSenderId: "426412173049"
  },
  prod: {
    apiKey: "AIzaSyAWTtiNRlKd9adGGu5eIwXGWFjnoWX4o_I",
    authDomain: "fibo-collab.firebaseapp.com",
    databaseURL: "https://fibo-collab.firebaseio.com",
    projectId: "fibo-collab",
    storageBucket: "fibo-collab.appspot.com",
    messagingSenderId: "312610876770"
  }
}

export default FirebaseConfig



// WEBPACK FOOTER //
// ./src/FirebaseConfig.js